module.exports = __webpack_public_path__ + "img/2025-06-11a_5.6b44c0d0.jpg";